import { EMAIL, IN_APP, PUSH } from 'constants/messageMediums';
import { INBOX_VIEW, IN_APP_VIEW, ANDROID, IOS } from 'modules/templatePreview/constants';
import { noop } from 'utils/noop';
import { SmallButtonGroup, GroupButton } from 'ui/buttonGroup';
import { Apple, Android } from 'ui/icons';

import { ActionContainer } from './TemplatePreview.styled';

// type Props = {
//   /** content is just a passed in object with strings
//    *  representing all of the text on the page.
//    *  this makes Justin Tulk happy because it's prep work
//    *  for a possible i18n future.
//    */
//   content?: {
//     inAppToggle: string,
//     inboxToggle: string,
//   },
//   /** the template message medium */
//   messageMedium?: EMAIL | IN_APP | PUSH | SMS | WEB_PUSH,
//   /** cb that fires when a toggle action is taken */
//   onToggle?: (selectedType: string) => void,
//   /** outside state depicting which toggle button has been selected */
//   selectedToggleButton?: string,
//   /** whether to show the in-app app/inbox toggle */
//   showInAppToggleButtons?: boolean,
//   /** whether to show the push apple/android toggle */
//   showPushToggleButtons?: boolean,
// };

// TODO: [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json
export const displayContent = {
  inAppToggle: 'In-app',
  inboxToggle: 'Inbox',
};

export const ActionBar = ({
  content = displayContent,
  messageMedium = EMAIL,
  onToggle = noop,
  selectedPushToggleButton = IOS,
  showInAppToggleButtons = false,
  showPushToggleButtons = false,
}) => {
  const isInAppMessage = messageMedium === IN_APP;
  const isPushMessage = messageMedium === PUSH;

  if (!isInAppMessage && !isPushMessage) {
    return null;
  }

  // an empty bar will take up visual space for no reason
  // so we don't show it if the preview is set up not to show the toggles
  if (isInAppMessage && !showInAppToggleButtons) {
    return null;
  }
  if (isPushMessage && !showPushToggleButtons) {
    return null;
  }

  return (
    <ActionContainer data-test="template-preview-action-buttons">
      {isInAppMessage && (
        <SmallButtonGroup defaultSelectedId={IN_APP_VIEW}>
          <GroupButton id={IN_APP_VIEW} onSelect={() => onToggle(IN_APP_VIEW)}>
            {content.inAppToggle}
          </GroupButton>
          <GroupButton id={INBOX_VIEW} onSelect={() => onToggle(INBOX_VIEW)}>
            {content.inboxToggle}
          </GroupButton>
        </SmallButtonGroup>
      )}
      {isPushMessage && (
        <SmallButtonGroup defaultSelectedId={selectedPushToggleButton}>
          <GroupButton aria-label={IOS} id={IOS} onSelect={() => onToggle(IOS)}>
            <Apple height={18} />
          </GroupButton>
          <GroupButton aria-label={ANDROID} id={ANDROID} onSelect={() => onToggle(ANDROID)}>
            <Android height={18} />
          </GroupButton>
        </SmallButtonGroup>
      )}
    </ActionContainer>
  );
};
